import { Component, OnInit } from '@angular/core';
import {Router,ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['./verify.component.scss']
})
export class VerifyComponent implements OnInit {
  productValue = null;
  totalfirstval = null;
  totalsecondval = null;
  orderNo = '';
  storecode = '';

  constructor(private router:Router,) { } 

  ngOnInit(): void {

    this.productValue = window.localStorage.getItem('productValue');
    this.orderNo = window.localStorage.getItem('orderNo');
    this.storecode = window.localStorage.getItem('storeReference');
  
    this.totalfirstval =   (Math.round(this.productValue * 100) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",").split('.')[0];
    this.totalsecondval =   (Math.round(this.productValue * 100) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",").split('.')[1];
    


  }
  backtohome() {
    this.router.navigateByUrl('')
  }

  twodecimal(amount) {
    const numb = (Math.round(amount * 100) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","); 
    return numb;
  }

}
 